import { useEffect, useState } from "react";
import { getCombos } from "../../services/CombosServices";
import { CombosContext } from "./CombosContext"


export const CombosState = ({ children }) => {
    const [data, setData] = useState()

    useEffect(() => {
        getCombosData()
    }, [])


    const getCombosData = async () => {
        const clienteSelected = JSON.parse(localStorage.getItem('clienteSelected'));
        let res = await getCombos(clienteSelected?.id)
        if (res) setData(res)
    }



    return <CombosContext.Provider value={{
        data,
        getCombosData
    }} >
        {children}
    </CombosContext.Provider>
}